interface ICondition<E> {
  (e: E): boolean;
}

/**
 * FastConditionalStrategy
 *
 * @description represents logic around a set of data (context) which reduces to a single algorithm selection
 */
export class FastConditionalStrategy<A, E> {
  constructor(private __rules: [A, ICondition<E>][]) {}

  evaluate(executionContext: E): A | undefined;
  evaluate(executionContext: E, fallback: A): A;

  evaluate(executionContext: E, fallback?: A): A | undefined {
    for (let [algorithm, condition] of this.__rules) {
      if (condition(executionContext)) {
        return algorithm;
      }
    }
    return fallback;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-strategy/src/lib/fast_conditional_strategy.ts